import { render, staticRenderFns } from "./request-transfer-modal.vue?vue&type=template&id=75ddc5b6&"
import script from "./request-transfer-modal.ts?vue&type=script&lang=ts&"
export * from "./request-transfer-modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports